import { Link } from 'react-router-dom'
import './footer.css'

import {AiOutlineCopyrightCircle} from 'react-icons/ai'

const Footer = () =>
{
    return(
        <footer>
            <div className="footer-copyright">
                <p>Copyright</p>
                <AiOutlineCopyrightCircle />
                <p>2022 Antino Kila. All rights reserved</p>
            </div>

            <div className="footer-socials">
                <p className='footer-socials-p'>Find me @ </p>
                <a className='footer-links' href='https://www.linkedin.com/in/antinokila/' target="_blank">LINKEDIN</a>
                <Link to="#" className='footer-links' onClick={() => window.location.href = 'mailto:ninokila91@gmail.com'}>GMAIL</Link>
            </div>
        </footer>
    )
}

export default Footer